import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { AnalyticsService } from '../../../../shared/services/analytics.service';

@Component({
  selector: 'app-managed-support-section',
  standalone: true,
  imports: [CommonModule, MatButtonModule, RouterModule],
  templateUrl: './managed-support-section.component.html',
  styleUrl: './managed-support-section.component.scss'
})
export class ManagedSupportSectionComponent {
  private readonly analytics = inject(AnalyticsService);

  readonly includedContrast = 'Included Support helps you use MemberTrace.';
  readonly managedContrast = 'Managed Support helps do the work inside MemberTrace.';
  readonly managedPrice = 'From $499/mo';

  readonly includedSupport = [
    'Email, chat, and phone support',
    'Product support and issue resolution',
    'Knowledge base and onboarding docs',
    'Standard onboarding and product guidance'
  ];

  readonly managedSupport = [
    'Recurring administration inside MemberTrace',
    'Configuration, content, member, and event setup',
    'Workflow optimization and regular check-ins'
  ];

  onManagedSupportCta(): void {
    this.analytics.trackCtaClick('pricing-managed-support-click');
  }
}
